import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import DataAnalyticPageBuilderService from '../../../services/DataAnalyticPageBuilderService';
import { PageSectors } from '../../../interfaces/DataAnalytics/Pages';
import Sectors from '../components/Sectors';

const Transaction = () => {
    const location = useLocation(),
        { t } = useTranslation(['f', 'b']),
        history = useHistory(),
        [sectors, setSectors] = useState<Array<PageSectors>>([]);
    const activTab = location.hash ? location.hash.replace('#', '') : '';

    const removeHandler = useCallback(
        async (pageId, id) => {
            try {
                await DataAnalyticPageBuilderService.deleteSection(`${pageId}`, `${id}`);
                setSectors((prev) => prev.filter((elem) => elem.id !== id));
            } catch (error: any) {
                toast(t(`b:${error.response.data.errorMessage}`));
            }
        },
        [t]
    );

    const editHandler = useCallback(
        (pageId, id, pageSectionDataId) => {
            history.push(`template/chart/${pageId}/add-content/left-heading-chart/chart-${id}:${pageSectionDataId}`);
        },
        [history]
    );

    const fetchSectorsForPage = useCallback(async () => {
        try {
            const _sectors = await DataAnalyticPageBuilderService.featchSections(activTab);
            setSectors(_sectors);
        } catch (error: any) {
            toast(t(`b:${error.response.data.errorMessage}`));
        }
    }, [activTab, t]);

    useEffect(() => {
        fetchSectorsForPage();
    }, [fetchSectorsForPage]);

    return (
        <div className="data-analytic__overview">
            {sectors.map((elem: PageSectors) => (
                <Sectors
                    {...elem}
                    removeHandler={() => removeHandler(elem.pageId, elem.id)}
                    editHandler={() => editHandler(elem.pageId, elem.id, elem.pageSectionDataId)}
                />
            ))}
        </div>
    );
};

export default Transaction;
